module.exports = __webpack_public_path__ + "static/media/tlc-pending.a3fc4bcf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Icons/tlc-pending.svg
// module id = 1583
// module chunks = 0